// Cliente HTTP compartilhado do CRM — extraído de Estoque/Patrimônio/
// Documentos, que duplicavam a mesma função fetch+token+baseURL+erro
// (Financeiro/Projetos têm sua própria cópia mais antiga, fora do escopo
// desta extração — ver nota de decisão em CRM_REESTRUTURACAO_CONTEXTO.md
// §9.5). Não é um framework — só evita a MESMA função se multiplicar de
// novo a cada módulo novo.

export function getCookie(nome) {
  const v = document.cookie.match('(^|;)\\s*' + nome + '\\s*=\\s*([^;]+)');
  return v ? v.pop() : '';
}

function base() {
  return process.env.REACT_APP_GESTAO_API_URL || '';
}

function authHeader() {
  return { Authority: getCookie('info') };
}

// JSON: GET/POST/PUT/DELETE com corpo JSON.
export async function apiJson(path, opts = {}) {
  const res = await fetch(`${base()}/api${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...authHeader(), ...(opts.headers || {}) },
  });
  return res.json();
}

// multipart/form-data — upload de arquivo (deixa o browser setar o
// Content-Type com o boundary correto, por isso não sobrescreve headers).
export async function apiForm(path, opts = {}) {
  const res = await fetch(`${base()}/api${path}`, { ...opts, headers: { ...authHeader(), ...(opts.headers || {}) } });
  return res.json();
}

// Download autenticado — devolve o Blob pra quem chamou decidir o que
// fazer (salvar como arquivo, abrir em nova aba, etc).
export async function apiDownload(path) {
  const res = await fetch(`${base()}/api${path}`, { headers: authHeader() });
  if (!res.ok) return null;
  return res.blob();
}

export function baixarBlob(blob, nomeArquivo) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = nomeArquivo || 'arquivo';
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
}
